import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { RouterContext, useRouter } from './Hooks';
import { matchedPath, requestIdleCallback, cancelIdleCallback } from './Utils';
import { Route } from './Route';

export const SubRouter = (props) => {
	const { path } = props;
	return <Route path={path} subrouter render={<Provider {...props} />} />;
};

SubRouter.propTypes = {
	path: PropTypes.string.isRequired,
	render: PropTypes.element.isRequired,
};

const Provider = ({ path, render }) => {
	const { state: consumer, setState: setConsumer } = useRouter();
	const [state, setState] = useState({
		...consumer,
		matched: false,
		isNoMatched: false,
		initial: true,
	});

	const { isMatched } = matchedPath(path, state.url, true, true);

	useEffect(() => {
		isMatched || setConsumer({ ...state });
	}, [isMatched, setConsumer, state]);

	useEffect(() => {
		/* there is no smooth way to deal with puting matched to false it 
		 conflict the first paint if i stop the first paint it will lost a little performance
		 but for now this is the most stable amongst them all pattern*/
		if (consumer.matched) {
			setState((prev) => ({
				...prev,
				initial: false,
				prevUrl: prev.url,
				...(prev.initial || {
					url: consumer.url,
					matched: false,
					isNoMatched: false,
				}),
			}));
		}
	}, [consumer]);

	useEffect(() => {
		if (state.matched || state.isNoMatched) return;
		const cleanup = requestIdleCallback(() =>
			setState((prev) => ({ ...prev, isNoMatched: true }))
		);
		return () => cancelIdleCallback(cleanup);
	}, [state]);

	useEffect(() => {
		typeof state.onUpdate === 'function' &&
			!state.initial &&
			state.url !== state.prevUrl &&
			(state.matched || state.isNoMatched) &&
			state.onUpdate.call(null, {
				url: state.url,
				matched: state.matched,
				initial: false,
				prevUrl: state.prevUrl,
			});
	}, [state]);
	
	const provider = { state, setState };
	return (
		<RouterContext.Provider value={provider}>{render}</RouterContext.Provider>
	);
};
